<script>
/**
 Type         : Page component
 Title        : 공지사항
 Description  : 공지사항 관리를 위한 페이지 컴포넌트
 
  1: 공지사항 - 고객
  2: 공지사항 - 파트너
  3: FAQ
  4: Q&A

 */


import Title from "@/components/admin/common/TitleArea.vue"
import NoticeList from "@/components/admin/common/list/NoticeList.vue"
import ModalNoticeRegi from "@/components/admin/common/modal/RegiNoticeForm.vue"


export default {
  name: "Admin-notice-manage",
  meta: {
    title: "어드민-공지사항관리"
  },
  components: {
    Title,
    NoticeList,
    ModalNoticeRegi,
  },
  data() {
    return {
      noticeModal : false,
      editorMode  : 0,  // 0: 등록모드, 1: 수정모드

      noticeListAdmin    : [],
      currPageAdmin      : 0,
      noticeListCustomer : [],
      currPageCustomer   : 0,

      authLevel   : 1,
      noticeData  : {
        id      : "",
        brdTyp  : 1,  // 1:공지사항 - 고객, 2:공지사항 - 파트너, 3:FAQ, 4:Q&A
        title   : "",
        writer  : "",
        isFixed : 1,
        isShown : 0
      },
      description   : {
        title : '공지사항 관리'
      },
    }
  },
  methods: {
    /**
     * 변경된 리스트의 타이틀 업데이트
     */
    updateList(editedData){
      this.$log.debug("Update notice edited title = > ", editedData)
      
      for(let i = 0; i < this.noticeList.length; i++){
        this.$log.debug("변경되어야 할 목록 id = > " + editedData.id)
        if(this.noticeList[i].id === editedData.id){
          this.$log.debug("변경되어야 할 id를 찾은 경우 = > " + this.noticeList[i].id)
          this.noticeList[i].title = editedData.title
        }
      }
    },

    /**
     * Title : 공지사항목록조회
     * Description  : 공지사항 목록을 불러온다.
     * - 관리자의 경우 전체 공지사항을 불러온다.
     * - 파트너의 경우 파트너 공지사항만 불러온다.
     * @param {*} curr : 현재 페이지 번호
     * @param {*} brdTyp : 공지사항 타입 (1: 고객 공지 , 2: 관리자/파트너 공지)
     */
    async loadNoticeList(curr, brdTyp) {
      let payload = {
        paging : curr,
        brdTyp : brdTyp,  // 1: 고객 공지 , 2: 관리자/파트너 공지
      }

      let config = {
        method  : "POST",
        url     : "/api/board/getNoticeList",
        data    : payload,
        name    : "[ Axios / 공지사항목록조회 ]"
      }

      await this.$http(config)
        .then(res => {
          this.$log.debug(res.data)

          const result = res?.data?.items

          if(result.length === 0 || result.length === undefined ){
            this.$q.notify({
              type: 'positive',
              message: '더 불러올 공지글이 없습니다.',
              position: 'top',
              timeout: 3000,
            })
          } else {
            let newNoticeList = result
            newNoticeList.map(item => {

              if(brdTyp === '2')
                this.noticeListAdmin.push(item)
              else if(brdTyp === '1')
                this.noticeListCustomer.push(item)
            })
          }
        })
        .catch((err) => {
          this.$log.debug(err)
          this.$q.notify({
            type: 'negative',
            message: '공지글 불러오기에 실패했습니다.',
            position: 'top',
            timeout: 3000,
          })
      })
    },

    /**
     * 공지사항 추가 모달 열기
     */
    callModalAddNotice(){
      this.noticeModal = true
      this.editorMode = 0
      // this.$refs.noticeRegi.initByParent()
    },

    /** 
     * 공지사항 수정
     */
    callModalEditNotice(selected){
      this.noticeModal    = true
      this.editorMode     = 1
      this.noticeData     = selected

      this.$log.debug("Edit notice executed => noticeModal : " + this.noticeModal + ", editorMode : " + this.editorMode)
      this.$log.debug("noticeData => ", selected)
    },

    /**
     * 모달 닫기
     */
    closeModal(){
      this.$log.debug("Notice board Close modal")
      this.noticeModal = false
    },

    /**
     * 초기화
     */
    async init(){
      // 권한 레벨 설정
      this.authLevel =  this.$getAuthLevel()

      // 공지사항 목록 초기화
      this.noticeListAdmin = []
      await this.loadNoticeList(0, '2')  // 공지사항 - 관리자
      
      // 관리자인 경우에만 파트너 목록을 불러온다.
      if(Number(this.authLevel) >= 90){
        // this.$getPartnerList()

        this.noticeListCustomer = []
        await this.loadNoticeList(0, '1')  // 공지사항 - 고객 
      }
    }
  },
  mounted() {
    this.$log.info("[ Page / 공지사항관리 ]")
    this.init()
  },
}
</script>


<template>
  <q-page class="q-pa-lg">
    <div class="row">
      <div class="col">
        <Title
          :desc="description">

          <q-btn
            label="공지사항 등록하기"
            color="primary"
            @click="callModalAddNotice">
          </q-btn>

        </Title>  
      </div>
    </div>

    <div class="row q-mt-md q-mb-md items-stretch">
      <div class="col col-12 col-lg-6">
        <div class="comp-box row q-mb-sm">
          <div class="col-12">
            <h3 class="title">공지사항 - 관리자</h3>
          </div>
          <div class="col-12">
            <NoticeList
              :notice-list="noticeListAdmin"
              @reload-parcel-list="loadNoticeList(0, '2')"
              @load-more-list="loadNoticeList(currPageAdmin + 1, '2')"
              @edit-modal="callModalEditNotice" />
          </div>
        </div>
      </div>
      <div class="col col-12 col-lg-6">
        <div class="comp-box row q-mb-sm">
          <div class="col-12">
            <h3 class="title">공지사항 - 고객</h3>
          </div>
          <div class="col-12">
            <NoticeList
              :notice-list="noticeListCustomer"
              @reload-parcel-list="loadNoticeList(0, '1')"
              @load-more-list="loadNoticeList(currPageAdmin + 1, '1')"
              @edit-modal="callModalEditNotice" />
          </div>
        </div>
      </div>
    </div>

  </q-page>

  <teleport to="body">
    <q-dialog 
      v-model="noticeModal">

      <ModalNoticeRegi 
        ref="noticeRegi"
        :editor-mode="editorMode"
        :notice-data="noticeData"
        @update-list="updateList"
        @close-modal="closeModal" />
  
    </q-dialog>
  </teleport>
  
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.comp-box {

  .title {
    font-size: 1rem;
    margin-top: 0;
    line-height: inherit;
  }

  .count {
    font-size: 1.4rem;
  }
}
</style>
